<script setup lang="ts">
const route = useRoute('tournaments-tournament-games-id')
const localePath = useLocalePath()
await navigateTo(localePath(`/live/${route.params.id}`))
</script>

<template>
  <div>Loading</div>
</template>
